"use client";

import { Box, FileUpload, Icon, Stack, Text } from "@chakra-ui/react";
import { LuUpload } from "react-icons/lu";

const ACCEPTED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
];
const MAX_FILE_SIZE_MB = 3;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
const MAX_FILES = 10;

interface DocumentUploadDropzoneProps {
  onFilesChange?: (files: File[]) => void;
}

const DocumentUploadDropzone = ({
  onFilesChange,
}: DocumentUploadDropzoneProps) => {
  return (
    <Stack gap={3}>
      <Text fontSize="sm" fontWeight="medium" color="text.primary">
        Upload packing list or invoice to estimate your shipping costs
      </Text>
      <FileUpload.Root
        maxFiles={MAX_FILES}
        maxFileSize={MAX_FILE_SIZE_BYTES}
        accept={ACCEPTED_FILE_TYPES}
        onFileChange={(details) => onFilesChange?.(details.acceptedFiles)}
      >
        <FileUpload.HiddenInput />
        <FileUpload.Dropzone
          w="100%"
          h="120px"
          minH="unset"
          px={4}
          borderStyle="dashed"
          borderColor="border.light"
          borderRadius="lg"
          cursor="pointer"
          _hover={{ borderColor: "border.dark" }}
        >
          <Icon size="md" color="fg.muted">
            <LuUpload />
          </Icon>
          <FileUpload.DropzoneContent>
            <Box fontSize="sm">Drop files here to upload documents</Box>
            <Box fontSize="xs">
              Accepts PDF or spreadsheet files, up to {MAX_FILE_SIZE_MB} MB per
              file
            </Box>
          </FileUpload.DropzoneContent>
        </FileUpload.Dropzone>
        <FileUpload.List showSize clearable />
      </FileUpload.Root>
    </Stack>
  );
};

export default DocumentUploadDropzone;
